export const SITE_URL = "https://funooni.com";

export const organizationSchema = {
  "@type": "Organization",
  name: "Funooni",
  url: SITE_URL,
  logo: `${SITE_URL}/logo192.png`,
  sameAs: ["https://www.instagram.com/funoonii/", "https://x.com/funoonii123"],
  description:
    "Funooni is a digital art and NFT marketplace focused on Arab artists, cultural heritage, and historical archive preservation.",
};

export const buildBreadcrumbSchema = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

export const buildVisualArtworkSchema = ({
  name,
  description,
  image,
  url,
  artistName,
  artMedium,
  artForm,
}) => ({
  "@type": "VisualArtwork",
  name,
  creator: {
    "@type": artistName ? "Person" : "Organization",
    name: artistName || "Funooni Archive",
  },
  ...(artForm && { artform: artForm }),
  ...(artMedium && { artMedium }),
  description,
  image,
  url,
  provider: {
    "@type": "Organization",
    name: "Funooni",
  },
});

export const buildGraph = (...schemas) => ({
  "@context": "https://schema.org",
  "@graph": schemas,
});

export const truncateDescription = (text, max = 155) => {
  if (!text) return "";
  const clean = text.replace(/\s+/g, " ").trim();
  return clean.length > max ? `${clean.slice(0, max - 1).trimEnd()}…` : clean;
};
